module.exports = __webpack_public_path__ + "img/jackpot-help.c43f6392.svg";